export default __webpack_public_path__ + "static/media/higher_primary_logo_reversed_no_margin.bcc0ac37.svg";